<template>
    <div></div>
</template>

<script>
    import axios from 'axios';
    import Vue from 'vue';
    import Visibility from 'visibilityjs';

    import ErrorsMixin from '../mixins/ErrorsMixin';

    window.Vue = Vue;
    window.ErrorsMixin = ErrorsMixin;
    window.axios = axios;
    window.Visibility = Visibility;

    export default {
        name: 'Ping',
        mixins: [ErrorsMixin],
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            intervalInMinutes: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {
                timer: null
            }
        },
        created: function () {
            this.timer = Visibility.every(this.intervalInMinutes * 60000, this.pingServer);
        },
        beforeDestroy: function () {
            if (this.timer != null) Visibility.stop(this.timer);
        },
        methods: {
            pingServer() {
                var url = this.apiBaseUrl;
                url += '/ping/refresh';
                console.log(url);
                axios
                    .get(url)
                    .then(response => {
                        this.statusInfo = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            this.showErrorsToast(currentErrors);
                        }
                    });
            },
        }
    }
</script>

